import React from "react";

const NavHamburger = ({ isOpen, toggleHamburger }) => {
  return (
    <button
      type="button"
      className={`mobile-menu-toggle ${isOpen ? "is-open" : ""}`}
      onClick={toggleHamburger}
      aria-label={isOpen ? "Close menu" : "Open menu"}
      aria-expanded={isOpen}
      data-testid="toggles"
    >
      <span className="mobile-menu-toggle-line" aria-hidden="true" />
      <span className="mobile-menu-toggle-line" aria-hidden="true" />
      <span className="mobile-menu-toggle-line" aria-hidden="true" />
    </button>
  );
};

export default NavHamburger;
